import Model from 'models/Model'
import { date } from 'helpers/format'
export default class Lessor extends Model {
  get lessorName() {
    return this.model.lessorName
  }

  get vendorId() {
    return this.model.vendorId
  }

  get companyId() {
    return this.model.companyId
  }

  get email() {
    return this.model.email
  }

  get mobiNo() {
    return this.model.mobiNo
  }

  get mailingAddress() {
    return this.model.mailingAddress
  }

  get notificationSMS() {
    return this.model.notificationSMS
  }

  get isRequested() {
    return this.model.status === 'WAITING_FOR_UPDATE'
  }

  get lastRequestUpdate() {
    return date(this.model.lastRequestUpdate, 'MMM dd,yyyy')
  }

  get profilePhoto() {
    return this.model.profilePhoto
  }
}
